import { render, staticRenderFns } from "./increaseTransactions.vue?vue&type=template&id=0e36f0dd&scoped=true"
import script from "./increaseTransactions.vue?vue&type=script&lang=js"
export * from "./increaseTransactions.vue?vue&type=script&lang=js"
import style0 from "./increaseTransactions.vue?vue&type=style&index=0&id=0e36f0dd&prod&lang=css"
import style1 from "./increaseTransactions.vue?vue&type=style&index=1&id=0e36f0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e36f0dd",
  null
  
)

export default component.exports